import { render, staticRenderFns } from "./ReadRule.vue?vue&type=template&id=90d8d57a&scoped=true&"
import script from "./ReadRule.vue?vue&type=script&lang=js&"
export * from "./ReadRule.vue?vue&type=script&lang=js&"
import style0 from "./ReadRule.vue?vue&type=style&index=0&id=90d8d57a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90d8d57a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VForm } from 'vuetify/lib/components/VForm';
installComponents(component, {VCard,VCol,VForm})
